import {isNil} from 'ramda';

/**
 * Number of decimal places a step or bound is written with, used to undo the
 * floating point drift of `min + steps * step` (e.g. 0.05 * 10 === 0.5000000000000001).
 */
function getDecimalPlaces(value: number) {
  const text = value.toString();
  const separatorIndex = text.indexOf('.');

  return separatorIndex === -1 ? 0 : text.length - separatorIndex - 1;
}

export function snapLevel(
  value: number | null,
  min: number,
  max: number,
  step: number
): number | null {
  if (isNil(value)) {
    return null;
  }

  if (step <= 0) {
    return Math.min(max, Math.max(min, value));
  }

  const precision = Math.max(getDecimalPlaces(step), getDecimalPlaces(min));
  const snapped = Number((min + Math.round((value - min) / step) * step).toFixed(precision));

  return Math.min(max, Math.max(min, snapped));
}
